import { entries } from "lodash-es";

import {
    extractValue,
    toHierarchicalFacetPath
} from "@/services/bffSearch/responseTransformers/mergeHierarchicalFacets.transformer";

import { Facet } from "../../@types/facet.types";
import {
    FacetType,
    RecursiveHierarchicalFacet
} from "../../@types/facetType.types";

export const facetValuesOfCategoryPageId = (
    facet: Facet<FacetType.HIERARCHICAL>,
    categoryPageIdFilter?: string
): Record<string, RecursiveHierarchicalFacet> => {
    const facetValues = entries(facet.values);

    return facetValues.length === 1 &&
        extractValue(facetValues[0][0]).identifier === categoryPageIdFilter
        ? facetValues[0][1].childValues
        : //@ts-ignore
          facet.values;
};

export const getShowAllCategories = (
    selectedValue?: string,
    categoryPageIdFilter?: string
) =>
    categoryPageIdFilter && selectedValue
        ? extractValue(toHierarchicalFacetPath(selectedValue).at(-1) ?? "")
              .identifier !== categoryPageIdFilter
        : true;
